<template>
  <el-card  class="box-card text-left cursor-pointer" shadow="never">
    <div @click="$router.push(`/dashboard/detail?courseId=${courseId}&type=${id}`)">
      <div  class="flex-display ai-center">
        <i :style="`color:${color}`" class="fas fa-user text-font-48"></i>
        <div class="pd-l-4">
          <p class="text-font-14 text-weight-500 mg-y-less">
            {{ label }}
          </p>
          <p class="text-font-30 mg-y-less">
            <span :style="`color:${color}`">{{ value | commaNoDot }} </span>
            <span class="text-font-18 text-weight-500">คน</span>
          </p>
        </div>
      </div>
      <div class="text-center">
        <span class="color-gray text-font-11">สรุปรายชื่อทั้งหมด</span>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    courseId:{
      type:String,
      default(){
        return ''
      }
    },
    id:{
      type:Number,
      default(){
        return ''
      }
    },
    label: {
      type: String,
      default() {
        return "";
      },
    },
    color: {
      type: String,
      default() {
        return "";
      },
    },
    value: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
};
</script>